var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_19)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00002 5.99997C9.00002 7.65682 7.65687 8.99997 6.00002 8.99997C4.34316 8.99997 3.00002 7.65682 3.00002 5.99997C3.00002 4.34312 4.34316 2.99997 6.00002 2.99997C7.65687 2.99997 9.00002 4.34312 9.00002 5.99997ZM11 5.99997C11 8.76139 8.76144 11 6.00002 11C3.2386 11 1.00002 8.76139 1.00002 5.99997C1.00002 3.23855 3.2386 0.999969 6.00002 0.999969C8.76144 0.999969 11 3.23855 11 5.99997ZM10.9735 9.55509L9.66671 10.8619L13.6963 14.8915C14.418 14.1697 14.418 12.9996 13.6963 12.2779L10.9735 9.55509Z",
    fill: "#00BF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaIcSearch);
export default __webpack_public_path__ + "static/media/pa_ic_search.92b7eb16c0eeadbb5c858c81393ee88d.svg";
export { ForwardRef as ReactComponent };